// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-permission-dialog .title[data-v-046916f4]{color:#000}.sub-permission-dialog .number-radio[data-v-046916f4]{margin-right:16px}", ""]);
// Exports
module.exports = exports;
